module.exports = __webpack_public_path__ + "media/dashboard/assets/images/mobile-quick-phrases-b3fd0fa59f754d6ee7363623e4dba59e.svg";